<template>
<div class="chapter">
<div class="inner_page">
<div id="cover-image" style="text-align:center">
<img alt="Just Ducky (A Lexie Starr Mystery, Book 5)" src="images/cover.png"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?60e2c848